<div *ngIf="hasCustomizations" class="customization-control" [ngClass]="{'flex-column': view === 'grid'}">
    <button *ngIf="canCustomize && !alreadyCustomized; else alreadyCustomizedTemplate" class="btn btn-outline-primary btn-edit-customization" (click)="handleCustomizationClick()"
            [disabled]="isFetching">
        <i *ngIf="isFetching" class="fa fa-sync rotate"></i>
        Customize
    </button>
</div>

<ng-template #alreadyCustomizedTemplate>
    <button *ngIf="canCustomize && !readonly" class="btn btn-outline-primary d-flex flex-row" (click)="handleCustomizationClick()"
            [disabled]="isFetching || isFetchingViewCustomization">
        <i *ngIf="isFetching" class="fa fa-sync rotate mr-2"></i>
        <span class="desktop-only">EDIT DESIGN</span>
        <span class="mobile-only">EDIT</span>
    </button>
    <ng-container *ngIf="hasOutput">
        <div *ngIf="isOutputImage" class="view-customization-wrapper">
            <button class="btn-view-customization" (click)="handleViewCustomization()"
                    [disabled]="isFetching || isFetchingViewCustomization">
                <i *ngIf="isFetchingViewCustomization" class="fa fa-sync rotate"></i>
                View {{orderItemDelivery?.chiliDesignName || 'Customization'}}
            </button>
            <div *ngIf="hasThumbnail" class="customization-tooltip">
                <img [src]="orderItemDelivery.chiliOutputThumbnail" alt="Customization preview" class="customization-tooltip-image" />
            </div>
        </div>
        <a *ngIf="!isOutputImage"  class="btn-view-customization" [href]="orderItemDelivery.chiliOutput" target="_blank">View Customization</a>
    </ng-container>
    <ng-container *ngIf="!hasOutput">
        <button class="btn-view-customization" (click)="showChiliStudioInReadonlyMode()"
                [disabled]="isFetching || isFetchingViewCustomization">
            <i *ngIf="isFetchingViewCustomization" class="fa fa-sync rotate"></i>
            View {{orderItemDelivery?.chiliDesignName || 'Customization'}}
        </button>
    </ng-container>

    <!-- Hidden gallery for full-screen preview -->
    <ngx-gallery #customizationGallery [options]="galleryOptions" [images]="galleryImages" class="hidden-gallery"></ngx-gallery>

</ng-template>
